import { Vue } from '@Ravnur-Inc/vue-class-component';

import './info.scss';
const CN = 'info';

class Props {
  message: string;
}

export default class Info extends Vue.with(Props) {
  render() {
    return (
      <div class={CN}>
        <icon class={`${CN}__icon`} type="info" />
        {this.message}
      </div>
    );
  }
}
